import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import {
  Form,
  Select,
  Space,
  DatePicker,
  Avatar,
  Badge,
  Row,
  Checkbox,
  Col,
  Input,
  Modal,
  Spin,
  message,
  Card,
} from "antd";
import { CSVLink } from "react-csv";
import { useSelector } from "react-redux";
import { CALL_API } from "../../../Common/api";
import styled from "styled-components";
import { shipmentType, TripTypeEnum } from "../../../Common/constant";
import Styled from "styled-components";
import UIModal from "../../../Reusablecomponents/UIModal";
import filtericon from "../../../assets/images/filter-svgrepo-com (1).svg";
import ExportIcon from "../../../assets/images/export-svgrepo-com (1).svg";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
import StyledTable from "../../../Reusablecomponents/UITable/UITable";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Pie,
  Cell,
  PieChart,
} from "recharts";
import { Buttontransparent } from "../../../Reusablecomponents/UIButtons";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { ButtonFilled } from "../../../Reusablecomponents/UIButtons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const Styledashboard = Styled.div`
.Custom {
  display: flex;
  align-items: center;
      justify-content: flex-end; /* Pushes content to the right */
  margin-bottom: 20px;
  gap: 20px;
}
    .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
     .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    
  }
    .timing-center {
    // margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    }
  .head {
  margin-bottom: 5px;
  color: #5f6d8c;
  height: 29px;
    // width: 84px;
  }
  .header-container {
  display: flex;
  justify-content: space-between; 
  align-items: center; 
  width: 100%;
}
  .consignment-value{
  color: #1F243B;
  font-size: 24px;
  font-weight: 600;
  }
  .total-mins{
  color: #363636;
    font-size: 20px;
  font-weight: 600;
  }
  `;
const TripReportAI = () => {
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState([null, null]);
  const { Option } = Select;
  const [filterCount, setFilterCount] = useState(0);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [tripCount, setTripCount] = useState({});
  const [tripChartData, setTripChartData] = useState([]);
  const [total, setTotal] = useState(0);
  const [tableData, setTableData] = useState([]);
  const vehicleListECSTS = useSelector(
    (state) => state?.authTracking?.userInfo,
  );
  const fenceList = useSelector((state) => state?.authTracking?.fenceList);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const [isconfigModalVisible, setIsconfigModalVisible] = useState(false);
  const [customDataLoaded, setCustomDataLoaded] = useState(false);
  const [AllCustomeData, SetAllCustomeData] = useState([]);

  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("AITRPT", "EX"),
    [reduxPermissions],
  );
  const csvLinkEl = useRef();
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };
  const vehicleOptions = vehicleList.filter((item, index) => {
    return (
      item?.FAgentGUID?.trim().toLowerCase() ===
      vehicleListECSTS?.ECTSCompId?.trim().toLowerCase()
    );
  });

  const filtervehlist = vehicleOptions?.map((item) => ({
    value: item?.FVehicleName,
    label: item?.FVehicleName,
  }));

  const deviceOptions = deviceList.map((item) => ({
    value: item.FGUID,
    label: item.FAssetID,
  }));
  // const [filterValues, setFilterValues] = useState({
  //   consignee: "",
  //   transporter: "",
  //   consignor: "",
  //   shipment: "",
  //   vehicleno: "",
  //   consigncode: "",
  //   trip: "",
  //   triptype: "",
  //   devices: "",
  // });
  const [filterValues, setFilterValues] = useState({});
  const [filterValues1, setFilterValues1] = useState({
    consignee: "",
    transporter: "",
    consignor: "",
    shipment: "",
    vehicleno: "",
    consigncode: "",
    trip: "",
    triptype: "",
    devices: "",
    daterange: "",
  });
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);

  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const fetchAllDevice = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllDevice");
      setDeviceList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      setVehicleList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchAllDevice();
    fetchAllVehicle();
  }, []);

  const getTripCount = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `aiReport/trip/getTripReporTotal?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format("YYYY-MM-DD")}`,
        {
          Vehid: filterValues?.vehicleno || "",
          Cust: filterValues?.consignor || 0,
          Shipper: filterValues?.transporter || 0,
          FID: filterValues?.fence || "",
          TripType: filterValues?.triptype || 0,
          Driver: filterValues?.driver || 0,
          Tripcode: filterValues?.trip || 0,
          Code: filterValues?.consigncode || 0,
          shipment: filterValues?.shipment || 0,
          ReferenceNo: filterValues?.ReferenceNo || "",
          ContainerNo: filterValues?.ContainerNo || "",
        },
      );
      setTripCount(data);
      setLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };
  const getTripChartData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `aiReport/trip?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=${currentPage}&PageSize=${pageSize} `,
        {
          Vehid: filterValues?.vehicleno || "",
          Cust: filterValues?.consignor || 0,
          Shipper: filterValues?.transporter || 0,
          FID: filterValues?.fence || "",
          TripType: filterValues?.triptype || 0,
          Driver: filterValues?.driver || 0,
          Tripcode: filterValues?.trip || 0,
          Code: filterValues?.consigncode || 0,
          shipment: filterValues?.shipment || 0,
          ReferenceNo: filterValues?.ReferenceNo || "",
          ContainerNo: filterValues?.ContainerNo || "",
        },
      );
      const newData1 = data?.TimeReport?.map((entityItem) => {
        const enrichedItem = { ...entityItem };

        // Attach custom field values by matching REFID to ConsignId
        const matchedFields =
          (Array.isArray(AllCustomeData) ? AllCustomeData : []).filter(
            (field) => Number(field.REFID) === Number(entityItem.CONSIGNID),
          ) || [];

        matchedFields.forEach((field) => {
          enrichedItem[field.CFID] = field.VALUE;
        });

        return enrichedItem;
      });
      setTripChartData(data);
      setTableData(newData1);
      setTotal(data?.TimeReport[0]?.TotalCount || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getTripChartData();
    }
  }, [filterValues, selectedDate, currentPage, pageSize]);

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getTripCount();
    }
  }, [filterValues, selectedDate]);
  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  //export functionality for trip time reprt tabel
  const prepareCSV = async (event, done, page = 1, pageSize = 10) => {
    try {
      setCSVLoader(true);

      const { data } = await CALL_API(
        "POST",
        `aiReport/trip?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=1&PageSize=${total}`,
        {
          Vehid: filterValues?.vehicleno || "",
          Cust: filterValues?.consignor || 0,
          Shipper: filterValues?.transporter || 0,
          FID: filterValues?.fence || "",
          TripType: filterValues?.triptype || 0,
          Driver: filterValues?.driver || 0,
          Tripcode: filterValues?.trip || 0,
          code: filterValues?.consigncode || 0,
          shipment: filterValues?.shipment || 0,
          ReferenceNo: filterValues?.ReferenceNo || "",
          ContainerNo: filterValues?.ContainerNo || "",
        },
      );
      const TripData = data?.TimeReport;
      // Apply sorting to match table sort order
      const sortedData = applySorting(data?.TimeReport);

      const customFieldMap = {};
      (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
        if (cf.CFID) {
          customFieldMap[cf.CFID] = cf.FIELDNAME || cf.FIELDCODE;
        }
      });
      const enrichedData = TripData.map((item) => {
        const matchedFields =
          (Array.isArray(AllCustomeData) ? AllCustomeData : []).filter(
            (f) => f.REFID === item.CONSIGNID,
          ) || [];

        const customFieldValues = {};

        // Ensure every custom field exists
        (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
          const fieldName = customFieldMap[cf.CFID] || `Custom_${cf.CFID}`;

          const matched = matchedFields.find((f) => f.CFID === cf.CFID);

          customFieldValues[fieldName] = matched?.VALUE || "-";
        });
        return {
          "Trip Code": item.CODE || "-",
          "Pickup Date & Time": item.PICKUPDATETIME
            ? `${dayjs
                .utc(item.PICKUPDATETIME)
                .tz("Africa/Nairobi")
                .format("DD/MM/YYYY hh:mm A")}`
            : "-",
          Vehicle: item.VehRegNo || "-",
          "ODO(Kms)": item.ODO ?? 0,
          "Carbon Footprint (KgCo2)": item.CarbonFootprint ?? 0,
          "Driver Name": item.DRIVERNAME || "-",
          "Trip Type": item.Triptype
            ? item.Triptype === 1
              ? "Local"
              : userInfo?.MCID === 72
                ? "Transit"
                : "Safari"
            : "-",
          "Loading Cycle": formatMinutes(item.LOADINGCYCLE) || "-",
          "Offloading Cycle": formatMinutes(item.OFFLOADINGCYCLE) || "-",
          "Consignment Count per Trip": item?.ConsignmentCount || 0,
          Consignor: item?.Consignor || "-",
          Transporter: item?.Transporter || "-",
          // Consignee: item?.FNAME || "-",
          "Delivery Time": formatMinutes(item?.Delivery) || "-",
          "Shipment Type": item?.ShipmentType
            ? item.ShipmentType === 1
              ? "Delivery"
              : "Collection"
            : "-",
          "Delivery Note Number": item?.FWayBill || "-",
          "Reference No": item?.ReferenceNo || "-",
          "Container No": item?.ContainerNo || "-",
           ...(userInfo?.MCID === 78 && {
              "Created By": item?.CreatedBy || "-",
              "Route Name": item?.RouteName || "-",
            }),
          ...customFieldValues,
        };
      });

      // Export if data exists
      if (enrichedData.length > 0) {
        setCSVList(enrichedData);
        setTimeout(() => csvLinkEl.current.link.click(), 500);
      } else {
        message.error("No data available to download.");
      }

      setCSVLoader(false);
    } catch (error) {
      setCSVLoader(false);
      console.error("[prepareCSV] error -->", error);
    }
  };

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(value).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };
  const { RangePicker } = DatePicker;
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  const handlechange = (value) => {
    setDuration(value);
  };
  const handlechangefordate = (date, dateString) => {
    setSelectedDate(date);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const tripStatusList = tripChartData?.TripStatus ?? [];

  const localData = tripStatusList.find((t) => t.TripType === "Local") || {};
  const safariData = tripStatusList.find((t) => t.TripType === "Safari") || {};

  const tripStatusData = [
    {
      name: "Not Started",
      Local: localData.NotStarted ?? 0,
      Safari: safariData.NotStarted ?? 0,
    },
    {
      name: "In Progress",
      Local: localData.InProgress ?? 0,
      Safari: safariData.InProgress ?? 0,
    },
    {
      name: "Completed",
      Local: localData.Completed ?? 0,
      Safari: safariData.Completed ?? 0,
    },
  ];

  const timeChartList = tripChartData?.TimeReportChart?.[0] ?? [];

  const avgLoading = timeChartList?.LoadingCycleVal ?? 0;
  const avgOffloading = timeChartList?.OffLoadingCycleVal ?? 0;

  // Combine average total time
  const avgTimeInMinutes = avgLoading + avgOffloading;

  // Format average time as HH:mm
  const avgTimeFormatted = `${String(
    Math.floor(avgTimeInMinutes / 60),
  ).padStart(2, "0")}:${String(Math.round(avgTimeInMinutes % 60)).padStart(
    2,
    "0",
  )}`;

  // Construct values (now using averages)
  const values = [
    {
      label: "Loading Cycle",
      color: "rgb(13,178,24)",
      time: avgLoading,
    },
    {
      label: "Offloading Cycle",
      color: "rgb(190,0,104)",
      time: avgOffloading,
    },
  ];

  // Legend with percentage and formatted time
  const chartLegendData = values.map((item) => ({
    ...item,
    percentage:
      avgTimeInMinutes > 0
        ? `${((item.time / avgTimeInMinutes) * 100).toFixed(2)}%`
        : "0.00%",
    time: `${String(Math.floor(item.time / 60)).padStart(2, "0")}:${String(
      Math.round(item.time % 60),
    ).padStart(2, "0")}`,
  }));

  // Data for chart
  const tripTimingData = values.map((item) => ({
    name: item.label,
    value: item.time,
    color: item.color,
  }));

  const formatMinutes = (value) => {
    if (value == null || isNaN(value)) return "-";
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle numeric fields
      if (
        [
          "ODO",
          "CarbonFootprint",
          "LOADINGCYCLE",
          "OFFLOADINGCYCLE",
          "Triptype",
          "Delivery",
        ].includes(tableSort.field)
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };
  const [customFields, setCustomFields] = useState([]);

  const customFieldOptions = Array.isArray(customFields)
    ? customFields.map((field) => ({
        label: field.FIELDNAME,
        value: field.CFID,
        disabled: false,
      }))
    : [];
  const [selectedCustomColumns, setSelectedCustomColumns] = useState([]);
  const GetAllCustomeData = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=${reftab}`,
      );

      SetAllCustomeData(data);
      setCustomDataLoaded(true);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };
  const loadCustomFields = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: reftab,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      title: "Trip Code",
      dataIndex: "CODE",
      key: "CODE",
      sorter: (a, b) => (a.CODE || "").localeCompare(b.CODE || ""),
      sortOrder: tableSort.field === "CODE" ? tableSort.order : null,
      render: (text) => <span style={{ color: "#1D4174" }}>{text}</span>,
    },
    {
      title: "Pick Up Date and Time",
      dataIndex: "PICKUPDATETIME",
      key: "PICKUPDATETIME",
      sorter: (a, b) =>
        (a.PICKUPDATETIME || "").localeCompare(b.PICKUPDATETIME || ""),
      sortOrder: tableSort.field === "PICKUPDATETIME" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";
        const dt = dayjs.utc(value).tz("Africa/Nairobi");
        return `${dt.format("DD/MM/YYYY")} ${dt.format("hh:mm A")}`;
      },
    },
    {
      title: "Vehicle",
      dataIndex: "VehRegNo",
      key: "VehRegNo",
      sorter: (a, b) => (a.VehRegNo || "").localeCompare(b.VehRegNo || ""),
      sortOrder: tableSort.field === "VehRegNo" ? tableSort.order : null,
    },
    {
      title: "Carbon Footprint (KgCo2)",
      dataIndex: "CarbonFootprint",
      key: "CarbonFootprint",
      sorter: (a, b) => (a.CarbonFootprint || 0) - (b.CarbonFootprint || 0),
      sortOrder: tableSort.field === "CarbonFootprint" ? tableSort.order : null,
      render: (value) => value ?? "-",
    },
    {
      title: "Driver Name",
      dataIndex: "DRIVERNAME",
      key: "DRIVERNAME",
      sorter: (a, b) => (a.DRIVERNAME || "").localeCompare(b.DRIVERNAME || ""),
      sortOrder: tableSort.field === "DRIVERNAME" ? tableSort.order : null,
    },
    {
      title: "ODO(Kms)",
      dataIndex: "ODO",
      key: "ODO",
      sorter: (a, b) => (a.ODO || 0) - (b.ODO || 0),
      sortOrder: tableSort.field === "ODO" ? tableSort.order : null,
      render: (value) => value ?? "-",
    },
    {
      title: "Trip Type",
      dataIndex: "Triptype",
      key: "Triptype",
      sorter: (a, b) => (a.Triptype || 0) - (b.Triptype || 0),
      sortOrder: tableSort.field === "Triptype" ? tableSort.order : null,
      render: (value) =>
        value === 1 ? "Local" : userInfo?.MCID === 72 ? "Transit" : "Safari",
    },
    {
      title: "Loading Cycle",
      dataIndex: "LOADINGCYCLE",
      key: "LOADINGCYCLE",
      sorter: (a, b) => (a.LOADINGCYCLE || 0) - (b.LOADINGCYCLE || 0),
      sortOrder: tableSort.field === "LOADINGCYCLE" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Offloading Cycle",
      dataIndex: "OFFLOADINGCYCLE",
      key: "OFFLOADINGCYCLE",
      sorter: (a, b) => (a.OFFLOADINGCYCLE || 0) - (b.OFFLOADINGCYCLE || 0),
      sortOrder: tableSort.field === "OFFLOADINGCYCLE" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Delivery Time",
      dataIndex: "Delivery",
      key: "Delivery",
      sorter: (a, b) => (a.Delivery || 0) - (b.Delivery || 0),
      sortOrder: tableSort.field === "Delivery" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    ...(userInfo?.MCID === 78
      ? [
          {
            title: "Container No",
            dataIndex: "ContainerNo",
            key: "ContainerNo",
            sorter: (a, b) =>
              (a.ContainerNo || "").localeCompare(b.ContainerNo || ""),
            sortOrder:
              tableSort.field === "ContainerNo" ? tableSort.order : null,
          },
          {
            title: "Reference No",
            dataIndex: "ReferenceNo",
            key: "ReferenceNo",
            sorter: (a, b) =>
              (a.ReferenceNo || "").localeCompare(b.ReferenceNo || ""),
            sortOrder:
              tableSort.field === "ReferenceNo" ? tableSort.order : null,
          },
        ]
      : []),
  ];
  const combinedColumns = useMemo(() => {
    const staticCols = [...columns];
    const staticColsForInterscope = [
        {
          title: "Created By",
          dataIndex: "CreatedBy",
          key: "CreatedBy",
          sorter: (a, b) => (a.CreatedBy || "").localeCompare(b.CreatedBy || ""),
          sortOrder: tableSort.field === "CreatedBy" ? tableSort.order : null,
          render: (value) => value ?? "-",
        },
        {
          title: "Route name",
          dataIndex: "RouteName",
          key: "RouteName",
          sorter: (a, b) => (a.RouteName || "").localeCompare(b.RouteName || ""),
          sortOrder: tableSort.field === "RouteName" ? tableSort.order : null,
          render: (value) => value ?? "-",
        }
    ];

    // Only show custom fields that are selected
    const dynamicCols = customFields
      .filter((field) => selectedCustomColumns.includes(field.CFID))
      .map((field) => ({
        title: field.FIELDNAME,
        dataIndex: field.CFID,
        key: field.CFID,
        sorter: false,
        render: (_, record) => record?.[field.CFID] ?? "-",
      }));

    return [...staticCols, ...staticColsForInterscope, ...dynamicCols];
  }, [columns, customFields, selectedCustomColumns]);
  const columnsForInterscope = [...combinedColumns, columns];
  const columnsLogic = userInfo?.MCID === 78 ? columnsForInterscope : columns;

  const totalTrips = tripCount?.TotalTrips?.[0]?.TotalTrips ?? 0;
  const LocalTrips = tripCount?.DeliveryTrips?.[0]?.DeliveryTrips ?? 0;
  const SafariTrips = tripCount?.CollectionTrips?.[0]?.CollectionTrips ?? 0;

  const importPercentage = totalTrips
    ? ((LocalTrips / totalTrips) * 100).toFixed(0)
    : 0;
  const exportPercentage = totalTrips
    ? ((SafariTrips / totalTrips) * 100).toFixed(0)
    : 0;
  useEffect(() => {
    if (customFields.length && selectedCustomColumns.length === 0) {
      setSelectedCustomColumns(customFields.map((f) => f.CFID));
    }
  }, [customFields]);
  useEffect(() => {
    const fetchAllCustomFields = async () => {
      setLoading(true);
      try {
        const [dataAIBulkcreate] = await Promise.all([
          CALL_API("POST", `mastertable/GetByReftab`, {
            ReftableId: "AIBulkcreate",
            RefId: 0,
            Active: 1,
            McId: userInfo?.MCID,
          }),
        ]);
        // Merge and deduplicate by CFID
        const allFields = [
          // ...(Array.isArray(dataAICONSIGN?.data) ? dataAICONSIGN.data : []),
          ...(Array.isArray(dataAIBulkcreate?.data)
            ? dataAIBulkcreate.data
            : []),
        ];
        // Only set empty if both are truly empty
        if (allFields.length === 0) {
          setCustomFields([]);
        } else {
          const uniqueFields = Object.values(
            allFields.reduce((acc, field) => {
              acc[field.CFID] = field;
              return acc;
            }, {}),
          );
          setCustomFields(uniqueFields);
        }
      } catch (error) {
        // Only clear if both failed
        setCustomFields([]);
        console.error("Error fetching custom fields:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllCustomFields();
    // GetAllCustomeData("AICONSIGN");
    GetAllCustomeData("AIBulkcreate");
    loadCustomFields("AIBulkcreate");
  }, []);
  useEffect(() => {
    if (
      customDataLoaded &&
      Array.isArray(customFields) &&
      customFields.length > 0 &&
      Array.isArray(selectedCustomColumns) &&
      selectedCustomColumns.length > 0
    ) {
      getTripChartData();
    }
  }, [customDataLoaded, customFields, selectedCustomColumns]);

  let tripTime = "Trip Timing (HH:MM)";
  return (
    <Styledashboard>
      {/* Conditional Content */}

      <div>
        <div
          className="total"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center", // Align items vertically
            width: "100%",
          }}
        >
          {/* Overview on the left */}
          <div className="head" style={{ flex: 1 }}>
            Overview
          </div>

          {/* Duration and Date Range on the right */}
          <div className="Custom" style={{ display: "flex", gap: "20px" }}>
            <div className="dropstyle">
              <Form.Item
                label=""
                name="dropdown"
                rules={[
                  { required: true, message: "Please select an option!" },
                ]}
              >
                <Select
                  placeholder="Custom Range"
                  onChange={handlechange}
                  defaultValue={duration}
                  className="plc"
                >
                  {Duration.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="dropstyle1">
              <Space direction="vertical" size={12}>
                <RangePicker
                  value={selectedDate}
                  onChange={handlechangefordate}
                />
              </Space>
            </div>
            <div>
              <Badge
                count={filterCount}
                className="badg"
                // onClick={() => setFilterModalOpen(true)}
                onClick={showModal}
              >
                <Avatar
                  shape="circle"
                  size="medium"
                  src={filtericon}
                  className="filterstyle"
                />
              </Badge>
            </div>
          </div>
        </div>
        <Spin spinning={loading}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#F9F9F9", // Light background color
              padding: "20px 30px", // Add padding for spacing
              borderRadius: "8px", // Rounded corners
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", // Subtle shadow
            }}
          >
            <div style={{ textAlign: "center", flex: 1 }}>
              <div
                style={{
                  fontSize: "18px",
                  color: "#363636",
                  marginBottom: "8px",
                }}
              >
                Total No. of Trips
              </div>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#101010",
                }}
              >
                {totalTrips}
              </div>
            </div>

            <div
              style={{
                width: "1px",
                height: "50px",
                backgroundColor: "#E0E0E0",
                margin: "0 20px",
              }}
            ></div>

            <div style={{ textAlign: "center", flex: 1 }}>
              <div
                style={{
                  fontSize: "18px",
                  color: "#363636",
                  marginBottom: "8px",
                }}
              >
                Delivery
              </div>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#101010",
                }}
              >
                {LocalTrips}
              </div>
              <div style={{ fontSize: "14px", color: "#5F6D8C" }}>
                {importPercentage}%
              </div>
            </div>

            <div
              style={{
                width: "1px",
                height: "50px",
                backgroundColor: "#E0E0E0",
                margin: "0 20px",
              }}
            ></div>

            <div style={{ textAlign: "center", flex: 1 }}>
              <div
                style={{
                  fontSize: "18px",
                  color: "#363636",
                  marginBottom: "8px",
                }}
              >
                Collection
              </div>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#101010",
                }}
              >
                {SafariTrips}
              </div>
              <div style={{ fontSize: "14px", color: "#5F6D8C" }}>
                {exportPercentage}%
              </div>
            </div>
          </div>
        </Spin>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            marginTop: "30px",
            flexWrap: "wrap", // Allows wrapping on smaller screens
          }}
        >
          <div
            style={{
              flex: "1 1 500px", // Grow/Shrink and min width
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              padding: "20px",
              maxWidth: "100%", // Prevent overflow
            }}
          >
            <div
              className="chart-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p
                className="pb-0 mb-0"
                style={{ fontWeight: 500, fontSize: "16px" }}
              >
                Trip Status
              </p>
              <img
                src={ExportIcon}
                alt="Export"
                style={{
                  width: "20px",
                  height: "20px",
                  cursor: "pointer",
                  backgroundColor: "#EBF7ED",
                  borderRadius: "6px",
                }}
                onClick={() =>
                  handleDownloadChart("Export Chart", "Trip Status")
                }
              />
            </div>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart
                layout="vertical"
                data={tripStatusData}
                margin={{ top: 50, right: 20, left: -10, bottom: 5 }}
                barCategoryGap="10%"
              >
                <Legend verticalAlign="top" align="right" />
                <Tooltip />
                <XAxis type="number" tickLine={false} axisLine={false} />
                <YAxis
                  dataKey="name"
                  type="category"
                  width={150}
                  tickLine={false}
                  axisLine={false}
                />
                <Bar dataKey="Safari" stackId="a" fill="#FFD464" />
                <Bar dataKey="Local" stackId="a" fill="#7064F5" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div
            style={{
              flex: "1 1 500px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <div
              className="chart-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p
                className="pb-0 mb-0"
                style={{ fontWeight: 500, fontSize: "16px" }}
              >
                Trip Timing
              </p>
              <img
                src={ExportIcon}
                alt="Export"
                style={{
                  width: "20px",
                  height: "20px",
                  cursor: "pointer",
                  backgroundColor: "#EBF7ED",
                  borderRadius: "6px",
                }}
                onClick={() =>
                  handleDownloadChart("Export Chart", "Trip Timing")
                }
              />
            </div>
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "250px",
                marginTop: "60px",
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={tripTimingData}
                    startAngle={180}
                    endAngle={0}
                    innerRadius={80}
                    outerRadius={140}
                    dataKey="value"
                    cx="50%"
                    cy="65%"
                  >
                    {tripTimingData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>

              <div
                style={{
                  position: "absolute",
                  top: "55%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  textAlign: "center",
                  pointerEvents: "none",
                }}
              >
                <div className="text-gray-400 text-sm">Total Time</div>
                <div className="total-mins">{totalTimeFormatted}(Hr:Min)</div>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "10px",
                marginTop: "-30px",
              }}
            >
              {chartLegendData.map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "17px",
                      height: "17px",
                      borderRadius: "50%",
                      backgroundColor: item.color,
                    }}
                  ></div>
                  <div style={{ flex: 1 }}>{item.label}</div>
                  <div>
                    {item.time} ({item.percentage})
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
        <UIModal
          width={600}
          height={600}
          open={isconfigModalVisible}
          onClose={() => {
            setIsconfigModalVisible(false);
          }}
          closeButton={false}
          size="md"
          header={
            <div className="text-start">
              <h2>Customized Column</h2>
              <label
                style={{ marginBottom: 8, display: "block", color: "#5F6D8C" }}
              >
                Columns
              </label>
            </div>
          }
          footer={
            <div className="mt-2 w-100 d-flex justify-content-end">
              <ButtonFilled
                onClick={() => {
                  setIsconfigModalVisible(false); // Close the modal
                }}
              >
                Save
              </ButtonFilled>
              <Buttontransparent
                onClick={() => {
                  setIsconfigModalVisible(false); // Just close the modal
                }}
              >
                Cancel
              </Buttontransparent>
            </div>
          }
        >
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Select custom columns"
            value={selectedCustomColumns}
            onChange={setSelectedCustomColumns}
            dropdownStyle={{ maxHeight: 250, overflow: "auto" }}
            dropdownRender={(menu) => (
              <div>
                <Checkbox.Group
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "8px 12px",
                  }}
                  value={selectedCustomColumns}
                  onChange={setSelectedCustomColumns}
                >
                  {customFieldOptions.map((option) => (
                    <Checkbox
                      key={option.value}
                      value={option.value}
                      disabled={option.disabled}
                    >
                      {option.label}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </div>
            )}
          >
            {customFieldOptions.map((option) => (
              <Select.Option
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </UIModal>
        <Styledashboard>
          <Spin spinning={loading}>
            <Row gutter={[12, 12]}>
              <Col xl={12} style={{ marginTop: "20px" }}>
                <div id="Export Chart">
                  <Card style={{ height: "410px" }}>
                    <div
                      style={{
                        flex: "1 1 500px", // Grow/Shrink and min width
                        backgroundColor: "",
                        borderRadius: "8px",
                        // boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                        padding: "20px",
                        maxWidth: "100%", // Prevent overflow
                      }}
                    >
                      <div
                        className="chart-header"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "0px",
                        }}
                      >
                        <p
                          className="pb-0 mb-0"
                          style={{ fontWeight: 500, fontSize: "16px" }}
                        >
                          Trip Status
                        </p>
                        <img
                          src={ExportIcon}
                          alt="Export"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: exportAllowed ? "pointer" : "not-allowed",
                            backgroundColor: "#EBF7ED",
                            borderRadius: "6px",
                          }}
                          onClick={() => {
                            if (!exportAllowed) return;
                            handleDownloadChart("Export Chart", "Trip Status");
                          }}
                        />
                      </div>

                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart
                          layout="vertical"
                          data={tripStatusData}
                          margin={{ top: 50, right: 20, left: -10, bottom: 5 }}
                          barCategoryGap="10%"
                        >
                          <Legend verticalAlign="top" align="right" />
                          <Tooltip />
                          <XAxis
                            type="number"
                            tickLine={false}
                            axisLine={false}
                          />
                          <YAxis
                            dataKey="name"
                            type="category"
                            width={150}
                            tickLine={false}
                            axisLine={false}
                          />
                          <Bar
                            dataKey={
                              userInfo?.MCID === 72 ? "Transit" : "Safari"
                            }
                            stackId="a"
                            fill="#FFD464"
                          />
                          <Bar dataKey="Local" stackId="a" fill="#7064F5" />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </Card>
                </div>
              </Col>
              <Col xl={12} style={{ marginTop: "20px" }}>
                <div id="Export Chart2">
                  <Card className="column_one">
                    <div
                      className="chart-header"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <p
                        className="pb-0 mb-0"
                        style={{ fontWeight: 500, fontSize: "16px" }}
                      >
                        {tripTime}
                      </p>
                      <img
                        src={ExportIcon}
                        alt="Export"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                          backgroundColor: "#EBF7ED",
                          borderRadius: "6px",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart("Export Chart2", "Trip Timing");
                        }}
                      />
                    </div>

                    <div className="timing_center_wrapper">
                      <ResponsiveContainer width="100%" height={290}>
                        <PieChart>
                          <Pie
                            data={tripTimingData}
                            startAngle={180}
                            endAngle={0}
                            innerRadius={80}
                            outerRadius={130}
                            dataKey="value"
                            cx="50%"
                            cy="50%"
                          >
                            {tripTimingData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="timing_center_wrapper_two">
                      {/* Centered Total Time */}
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          textAlign: "center",
                          pointerEvents: "none",
                        }}
                      >
                        <div className="total-mins">{avgTimeFormatted} </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px",
                        marginTop: "0px",
                      }}
                    >
                      {chartLegendData.map((item, i) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              width: "17px",
                              height: "17px",
                              borderRadius: "50%",
                              backgroundColor: item.color,
                            }}
                          ></div>
                          <div style={{ flex: 1 }}>{item.label}</div>
                          <div>
                            {item.time} ({item.percentage})
                          </div>
                        </div>
                      ))}
                    </div>
                  </Card>
                </div>
              </Col>
              <Col xl={12} style={{ marginTop: "20px" }}>
                {/* <Card className="column_one">hello world</Card> */}
              </Col>
            </Row>
          </Spin>
        </Styledashboard>

        <br />
        <div className="header-container">
          <div className="head">{total} records found.</div>
          <div>
            <Spin spinning={CSVLoader}>
              <img
                src={ExportIcon}
                style={{ cursor: exportAllowed ? "pointer" : "not-allowed" }}
                alt="Upload Icon"
                className="hover-image"
                onClick={() => {
                  if (!exportAllowed) return;
                  prepareCSV();
                }}
              />
            </Spin>
            <CSVLink
              data={CSVList}
              filename={"TripTimeReport.csv"}
              asyncOnClick={true}
              ref={csvLinkEl}
            />
          </div>
        </div>
        <br />

        <div>
          {tripChartData?.TimeReport && tripChartData.TimeReport.length > 0 && (
            <StyledTable
              dataSource={tableData}
              columns={columnsLogic}
              pagination={false}
              onChange={(pagination, filters, sorter) => {
                setTableSort({
                  field: sorter.field,
                  order: sorter.order,
                });
              }}
            />
          )}
        </div>

        <Modal
          open={isModalOpen}
          onCancel={handleCancel}
          width={900}
          footer={
            <ButtonFilled
              onClick={() => {
                form.resetFields();
                setFilterValues({});
              }}
            >
              {" "}
              Clear All{" "}
            </ButtonFilled>
          }
        >
          <Row>
            <Col xl={24} xs={{ span: 24, order: 2 }}>
              <div className="container_for_kpi_filter">
                <h6 className="Filter_for_clickablerow">
                  Filter ({filterCount})
                </h6>
                {/* <p className="Filter_for_Result">4 Result Found </p> */}
              </div>
            </Col>
          </Row>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(value, allvalues) => {
              getFilterCount();
              setFilterValues(allvalues);
            }}
          >
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Vehicle No" name="vehicleno">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={filtervehlist}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consignor" name="consignor">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consignerList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Transporter" name="transporter">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={transporterList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consignee" name="fence">
                  <Select
                    className="w-100"
                    showSearch
                    loading={loading}
                    optionFilterProp="children"
                    options={fenceList?.map((item) => ({
                      label: item.FName,
                      value: item.FGUID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consign Code" name="consigncode">
                  <Input placeholder="" className="rounded-pill" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Trip Code" name="trip">
                  <Input placeholder="" className="rounded-pill" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Trip Type" name="triptype">
                  <Select
                    className="w-100"
                    showSearch
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  >
                    <Option value={2}>
                      {userInfo?.MCID === 72 ? "Transit" : "Safari"}
                    </Option>
                    <Option value={1}>Local</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Shipment Type" name="shipment">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={shipmentType?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              {userInfo?.MCID === 78 && (
                <>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item label="Container No" name="ContainerNo">
                      <Input placeholder="" className="rounded-pill" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={6}>
                    <Form.Item label="Reference No" name="ReferenceNo">
                      <Input placeholder="" className="rounded-pill" />
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>
          </Form>
        </Modal>
      </div>

      <ReusablePagination
        pageSize={pageSize}
        handlePageSizeChange={handlePageSizeChange}
        currentPage={currentPage}
        total={total}
        handlePageChange={handlePageChange}
      />
    </Styledashboard>
  );
};

export default TripReportAI;
